var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{staticClass:"strech",attrs:{"title":_vm.tituloPersonalizado}}),(! _vm.isLfp)?[_c('RenovarAbono')]:[_c('RenovarAbonoLfp')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }